import * as React from 'react';

/** A tip is money: never let a bad number reach the form or the payload. */
const toAmount = (value: number) =>
  Number.isFinite(value) ? Math.round(value * 100) / 100 : 0;

/**
 * A tip is either a percentage or an amount, never both. A percentage is
 * resolved by the API against the same total it bills, so it stays correct as
 * the cart changes without the client recalculating — and without the extra
 * estimate a recalculation here would cost.
 */
export default function useCheckoutTip({
  amount,
  percent,
  setFieldValue,
}: {
  /** The resolved tip, from the estimate when a percentage is set. */
  amount: number | undefined;
  percent: number | null | undefined;
  setFieldValue: (field: string, value: any) => void;
}) {
  const set = React.useCallback(
    (tip: { amount: number; percent: number | null }) => {
      setFieldValue('tipPercentage', tip.percent ?? null);
      setFieldValue('tipAmt', tip.percent != null ? 0 : toAmount(tip.amount));
    },
    [setFieldValue],
  );

  return {
    amount: toAmount(amount ?? 0),
    percent: percent ?? null,
    set,
    clear: React.useCallback(() => set({ amount: 0, percent: null }), [set]),
  };
}
